import { useMemo, useState } from "react";
import { Header, SpaceBetween, Tiles } from "@cloudscape-design/components";
import IncredableContent from "../components/incredable-content";
import DocumentRequest from "./document-requests/document-request-list";
import EsignatureListV2 from "./signature-requests/e-signature-list-v2";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useGetOrganizationDetailsQuery } from "../redux/api/organization/organization";
import IncredableButton from "../components/button";
import Drawer from "react-modern-drawer";
import { Card, Col, Flex, Form, Row, Space } from "antd";
import { FormProvider, useForm } from "react-hook-form";
import RHFSelect from "../components/RHF/RHFSelect";
import { useGetBasicAllProvidersQuery } from "../redux/api/provider/provider";
import {
  useGetAllRequestTemplatesQuery,
  useSendRequestTemplateMutation,
} from "../redux/api/requesttemplate/requesttemplate";
import { SendRequestType } from "../redux/api/requesttemplate/type";

export default function AdminRequests() {
  const methods = useForm<SendRequestType>();

  const { data } = useGetOrganizationDetailsQuery();
  const [searchParams, setSearchParams] = useSearchParams({
    type: "signature_requests",
  });

  const selectedTab = useMemo(() => {
    return searchParams.get("type") ?? "signature_requests";
  }, [searchParams]);
  const [isOpen, setIsOpen] = useState(false);
  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };

  const [sendRequest] = useSendRequestTemplateMutation();

  const { data: providers } = useGetBasicAllProvidersQuery();
  const { data: requesttemaplates } = useGetAllRequestTemplatesQuery();

  if (
    !!data?.organizationServiceLimits?.eSignatures &&
    !!data?.settings?.enableMobileApp
  )
    return (
      <IncredableContent style={{ margin: "32px 32px 0 32px" }}>
        <SpaceBetween size="l" direction="vertical">
          <Header
            actions={
              <IncredableButton type="primary" onClick={toggleDrawer}>
                Request from template
              </IncredableButton>
            }
          >
            Requests
          </Header>
          <Tiles
            onChange={({ detail }) => {
              setSearchParams({ type: detail.value });
            }}
            value={selectedTab} // Use selectedTab as the value for Tiles
            items={[
              {
                label: "Signature Requests",
                description: "Signature Requests",
                value: "signature_requests",
              },
              {
                label: "Document Requests",
                description: "Document Requests",
                value: "document_requests",
              },
            ]}
          />
          {selectedTab === "signature_requests" && <EsignatureListV2 />}
          {selectedTab === "document_requests" && <DocumentRequest />}
        </SpaceBetween>
        <Drawer
          open={isOpen}
          onClose={toggleDrawer}
          direction="right"
          size="70vw"
        >
          <div style={{ padding: "24px" }}>
            <Card title={<Header>Request from template</Header>}>
              <FormProvider {...methods}>
                <Form
                  name="editsection"
                  layout="vertical"
                  onFinish={methods.handleSubmit(
                    async (data: SendRequestType) => {
                      sendRequest(data);
                      toggleDrawer();
                      methods.reset();
                    }
                  )}
                  autoComplete="off"
                >
                  <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col span={8}>
                      <RHFSelect
                        formItemProps={{ label: "Select Providers" }}
                        controllerProps={{
                          name: `providerId`,
                        }}
                        selectProps={{
                          allowClear: true,
                          showSearch: true,
                          style: { width: "100%" },
                          placeholder: "Search to Select",
                          options: providers?.map((provider) => {
                            return {
                              label: `${provider?.firstName} ${provider?.lastName}`,
                              value: provider?.id,
                            };
                          }),
                        }}
                        rules={{ required: "This field is required" }}
                      />
                    </Col>
                    <Col span={8}>
                      <RHFSelect
                        formItemProps={{ label: "Select Request Templates" }}
                        controllerProps={{
                          name: `templateId`,
                        }}
                        selectProps={{
                          allowClear: true,
                          showSearch: true,
                          style: { width: "100%" },
                          placeholder: "Search to Select",
                          options: requesttemaplates?.map(
                            (requesttemaplate) => {
                              return {
                                label: requesttemaplate?.name,
                                value: requesttemaplate?.id,
                              };
                            }
                          ),
                        }}
                        rules={{ required: "This field is required" }}
                      />
                    </Col>

                    <Col span={16}>
                      <Flex justify="flex-end">
                        <Space>
                          <IncredableButton type="primary" htmlType="submit">
                            Send
                          </IncredableButton>
                          <IncredableButton
                            secondary
                            onClick={() => {
                              methods.reset();
                              !!toggleDrawer && toggleDrawer();
                            }}
                          >
                            Cancel
                          </IncredableButton>
                        </Space>
                      </Flex>
                    </Col>
                  </Row>
                </Form>
              </FormProvider>
            </Card>
          </div>
        </Drawer>
      </IncredableContent>
    );
  else if (!!data?.settings?.enableMobileApp)
    return (
      <div style={{ padding: "32px 32px 0 32px" }}>
        <DocumentRequest />
      </div>
    );
  else
    return (
      <div style={{ padding: "32px 32px 0 32px" }}>
        <EsignatureListV2 />
      </div>
    );
}
